import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { IActionFormProps } from '@makyoapp/makyo-common'
import { Button, ButtonVariant, Field, Label } from '@makyoapp/makyo-ui'

import { useForm } from '@/lib/use-form'
import { ActionInputV3 } from '@/components/ActionInputV3/ActionInputV3'

export default function ActFormMakePhoneCall({ onSubmit, onDismiss, initialData }: IActionFormProps) {
  const { form, onSubmit: onFormSubmit } = useForm({
    defaultValues: {
      value: initialData?.value || {},
    },
    validate(data, setError) {
      let isManualInput = !data.value.tableId && !data.value.dataType
      let phoneValue = data.value.value
      let isPhoneEmpty = !phoneValue?.trim().length
      let validPhone = isManualInput && /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]{8,14}$/g.test(phoneValue)

      let phoneError = isPhoneEmpty
        ? 'Phone can not be empty'
        : isManualInput && !validPhone
          ? 'Please enter a valid phone number'
          : null

      setError('value', phoneError)
    },
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  const phone = form.getValues('value')
  const invalidForm = !phone?.value?.trim().length || !!form.errors

  return (
    <div>
      <div className='p-4'>
        <Field>
          <Label required>Phone</Label>
          <ActionInputV3
            options={initialData?.actionOptions}
            isActionWorkflow={initialData?.isActionWorkflow}
            placeholder='Enter Phone'
            value={form.getValues('value')}
            columnTypes={[ColumnTypes.Phone]}
            onChange={({ ...value }) => {
              form.setValues('value', value)
            }}
            error={form.errors?.value}
          />
        </Field>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit} disabled={invalidForm}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  )
}
